export enum PaymentType {
  AP = 'ap',
  AR = 'ar',
}
